import { Button as RoccoButton } from '@rocco/components/button';
import { ReactComponent as FiltersIcon } from '@rocco/icons/svg/filters.svg';

interface CollapsibleToggleProps {
    filterDrawerOpen: boolean;
    toggleFilterDrawer: () => void;
}

export const CollapsibleToggle = ({
    filterDrawerOpen,
    toggleFilterDrawer,
}: CollapsibleToggleProps) => {
    return (
        <RoccoButton
            color="dark"
            aria-label={`${filterDrawerOpen ? 'Hide filters' : 'Filters'}`}
            onClick={toggleFilterDrawer}
            clickAnimation="scale"
            weight="normal"
        >
            <FiltersIcon className="mr-2 size-4.5" />
            {filterDrawerOpen ? 'Hide filters' : 'Show Filters'}
        </RoccoButton>
    );
};
